import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/privacidad" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/terminos" element={<Terms data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}